import CardHeader from '@mui/material/CardHeader';
import { ReactNode } from 'react';

const styles = {
  root: {
    '& .MuiCardHeader-title': {
      color: 'card.header',
      fontWeight: 'bold',
    },
    borderBottom: '1px solid',
    borderBottomColor: 'divider',
    p: 3,
  },
};

interface IDashboardCardHeaderProps {
  action?: ReactNode;
  title: string | ReactNode;
}

export function DashboardCardHeader({ action = null, title }: IDashboardCardHeaderProps) {
  return (
    <CardHeader
      action={action}
      sx={styles.root}
      title={title}
      slotProps={{
        title: {
          variant: 'body1',
        },
      }}
    />
  );
}
